import React from 'react';
import './styles.css';
import { PageLayout } from '@BUP/components';
import { useAuth } from '@BUP/hooks';
import DataTeacherPage from '../dataTeacherPage';
import DataStudentPage from '../dataStudentPage';
import DataCounselorPage from '../dataCounselorPage';

const DataPage = () => {
  const { user } = useAuth();
  const roleType = user?.roles?.type;

  switch (roleType) {
    case 'COUNSELOR':
      return (
        <PageLayout>
          <DataCounselorPage />
        </PageLayout>
      );
    case 'TEACHER':
      return (
        <PageLayout>
          <DataTeacherPage />
        </PageLayout>
      );
    case 'ASSISTANT':
      return (
        <PageLayout>
          <DataTeacherPage />
        </PageLayout>
      );
    case 'STUDENT':
      return (
        <PageLayout>
          <DataStudentPage />
        </PageLayout>
      );
    case 'PARENT':
      return (
        <PageLayout>
          <DataStudentPage />
        </PageLayout>
      );
    default:
      return null;
  }
};

export default DataPage;
